import React from 'react';
import { Card, Row,Col } from 'react-bootstrap';
import { getTopRpList } from '../../components';

const TopRPCard = ({ roleplayActivity }) => {
    return (
        <Card className={"m-2 score-card-eom-overview"} >
            <Card.Header className={"going-on-header"}>
                <Card.Title>Busiest Roleplayers of the Day</Card.Title>
            </Card.Header>
            <Card.Body>
                {roleplayActivity.map((rper, index) =>
                    <Row key={index}>
                        <Col>{rper.userName}</Col>
                        <Col>{rper.rpxp}</Col>

                    </Row>)}

            </Card.Body>
        </Card>
    );
}

const getTopRpData = async (setRoleplayActivity) => {
    let data = await getTopRpList();
    if (data.result)
        setRoleplayActivity(data.rpdata);
    else {
        setRoleplayActivity([]);
    }
}

export { TopRPCard, getTopRpData };
